// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NFK42","clinicsSelect":"styles_clinicsSelect__3hy50"};